var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgSadOutline = function SvgSadOutline(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,37 C27.2386,37 25,34.53754 25,31.5 C25,28.46246 27.2386,26 30,26 C32.7614,26 35,28.46246 35,31.5 C35,34.53754 32.7614,37 30,37 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,37 C61.2390001,37 59,34.53754 59,31.5 C59,28.46246 61.2390001,26 64,26 C66.7609999,26 69,28.46246 69,31.5 C69,34.53754 66.7609999,37 64,37 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,94 C72.95716,94 94,72.95716 94,47 C94,21.042605 72.95716,0 47,0 C21.042605,0 0,21.042605 0,47 C0,72.95716 21.042605,94 47,94 Z",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25,68 C25,68 32.5,57 47.5,57 C62.5,57 70,68 70,68",
    strokeWidth: 6
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgSadOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "sad-outline.7fc39336a0845912b4e36857300e3026.svg";